"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowClear = void 0;
var keys_1 = require("../../keys");
var utils_1 = require("../../utils/utils");
var listener_1 = require("../../utils/event-listener/listener");
var event_trigger_1 = require("../../utils/event-trigger");
var element_from_string_1 = require("../../utils/element-from-string");
var AllowClear = function (target) {
    return /** @class */ (function (_super) {
        __extends(AllowClear, _super);
        function AllowClear() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AllowClear.prototype.binding = function (select, container) {
            var _this = this;
            _super.prototype.binding.call(this, select, container);
            if (this.placeholder == null) {
                if (this.options.get('debug') && window.console && console.error) {
                    console.error('TsSelect2: The `allowClear` option should be used in combination ' +
                        'with the `placeholder` option.');
                }
            }
            listener_1.createListener({
                elements: this.selection,
                events: 'mousedown',
                listeners: this.core.listeners,
                filter: function (event) {
                    var target = event.target;
                    var isClosed = function (el) { return el.classList.contains('select2-selection__clear'); };
                    return isClosed(target) || isClosed(target.parentElement);
                },
                callback: function (evt) {
                    _this._handleClear(evt);
                }
            });
            select.on('keypress', function (evt) {
                _this._handleKeyboardClear(evt, select);
            });
        };
        AllowClear.prototype._handleClear = function (evt) {
            // Ignore the event if it is disabled
            if (this.isDisabled()) {
                return;
            }
            var clears = this.selection.querySelectorAll('.select2-selection__clear');
            // Ignore the event if nothing has been selected
            if (clears.length === 0) {
                return;
            }
            evt.stopPropagation();
            var data = utils_1.Utils.GetData(clears[0], 'data');
            var previousVal = this.core.element.value;
            this.core.element.value = this.placeholder.id;
            var unselectData = {
                data: data
            };
            this.trigger('clear', unselectData);
            if (unselectData.prevented) {
                this.core.element.value = previousVal;
                return;
            }
            for (var d = 0; d < data.length; d++) {
                unselectData = {
                    data: data[d]
                };
                // Trigger the `unselect` event, so people can prevent it from being
                // cleared.
                this.trigger('unselect', unselectData);
                // If the event was prevented, don't clear it out.
                if (unselectData.prevented) {
                    this.core.element.value = previousVal;
                    return;
                }
            }
            event_trigger_1.eventTrigger(this.core.element, 'input');
            event_trigger_1.eventTrigger(this.core.element, 'change');
            this.trigger('toggle', {});
        };
        AllowClear.prototype._handleKeyboardClear = function (evt, select) {
            if (select.isOpen()) {
                return;
            }
            if (evt.which === keys_1.KEYS.DELETE || evt.which === keys_1.KEYS.BACKSPACE) {
                this._handleClear(evt);
            }
        };
        AllowClear.prototype.update = function (data) {
            _super.prototype.update.call(this, data);
            var clearEl = this.selection.querySelector('.select2-selection__clear');
            if (clearEl) {
                clearEl.remove();
            }
            if (this.selection.querySelectorAll('.select2-selection__placeholder').length > 0 || data.length === 0) {
                return;
            }
            var selectionId = this.selection
                .querySelector('.select2-selection__rendered')
                .getAttribute('id');
            var removeAll = this.options.get('translations').get('removeAllItems');
            var removeButton = element_from_string_1.elementFromString('<button type="button" class="select2-selection__clear" tabindex="-1">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>');
            removeButton.setAttribute('title', removeAll());
            removeButton.setAttribute('aria-label', removeAll());
            removeButton.setAttribute('aria-describedby', selectionId);
            utils_1.Utils.StoreData(removeButton, 'data', data);
            this.selection.prepend(removeButton);
        };
        return AllowClear;
    }(target));
};
exports.AllowClear = AllowClear;
//# sourceMappingURL=allow-clear.js.map